import React from 'react';
import { useIntl } from 'react-intl';
import { musicServicesByImporterID } from 'fym-shared/src/music-services/allMusicServices';
import { TypedMemo } from '../../../common/types';
import { IntegrationTypeIcon, integrationTypeToImporterId } from '../IntegrationTypeIcon/IntegrationTypeIcon';

interface TrackServiceLinksProps {
  links: { integrationType: string; url: string }[];
}

const TrackServiceLinksComponent: React.FC<TrackServiceLinksProps> = ({ links }) => {
  const intl = useIntl();
  if (links.length === 0) {
    return null;
  }
  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {links.map((link) => {
        const importerId = integrationTypeToImporterId[link.integrationType];
        const service = importerId !== undefined ? musicServicesByImporterID[importerId] : undefined;
        const serviceName = service?.shortName ?? service?.name ?? link.integrationType;
        const label = intl.formatMessage(
          { id: 'app.sml.track.details.openOnService', defaultMessage: 'Open on {service}' },
          { service: serviceName }
        );
        return (
          <a
            key={link.integrationType}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-secondary btn-sm rounded-pill px-3 d-inline-flex align-items-center gap-2"
            aria-label={label}
          >
            <IntegrationTypeIcon integrationType={link.integrationType} size={16} />
            <span className="fw-medium">{label}</span>
          </a>
        );
      })}
    </div>
  );
};

export const TrackServiceLinks = TypedMemo(TrackServiceLinksComponent);
